import * as React from "react";
import ConfigContext from "../context/ConfigContext";
import { EngagementConfiguration } from "../types";
import StoreContainer from "../stores/StoreContainer";

interface ConfigStyleProps {
  config: EngagementConfiguration;
}

class ConfigStyle extends React.Component<ConfigStyleProps, {}> {
  getPrimaryBackgroundColor() {
    return this.props.config.PrimaryBackgroundColor || "#75b9e6";
  }

  getHeaderTransparency() {
    if (this.props.config.HeaderTransparency === undefined) {
      return 0.9;
    }

    return this.props.config.HeaderTransparency;
  }

  getHeaderBackgroundColor() {
    return this.addTransparencyToHexColor(
      this.getPrimaryBackgroundColor(),
      this.getHeaderTransparency()
    );
  }

  addTransparencyToHexColor(color: string, trans: number) {
    const rgb = this.getRgb(color);
    return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${trans})`;
  }

  getRgb(args: any) {
    const match = args.toString(16).match(/[a-f0-9]{6}/i);

    if (!match) {
      return [0, 0, 0];
    }

    const integer = parseInt(match[0], 16);
    const r = (integer >> 16) & 0xff;
    const g = (integer >> 8) & 0xff;
    const b = integer & 0xff;

    return [r, g, b];
  }

  getFontFamily() {
    switch (this.props.config.Font) {
      case "arial":
        return "Arial";
      case "open_sans":
        return "'Open Sans', sans-serif";
      case "roboto":
        return "'Roboto', sans-serif";
      case "source_sans_pro":
        return "'Source Sans Pro', sans-serif";
      default:
        return "'Open Sans', sans-serif";
    }
  }

  getWidthHeightOrScale() {
    let style = "width: 80px;height: 80px;";

    if (this.props.config.ChatHeaderImageScale) {
      style += `transform: scale(${this.props.config.ChatHeaderImageScale / 100
        });`;
    }

    return style;
  }

  getLogoWidthHeightOrScale() {
    let style = "height: 60px;";

    if (this.props.config.ChatHeaderImageScale) {
      style += `transform: scale(${this.props.config.ChatHeaderImageScale / 100
        });`;
    }

    return style;
  }

  getLGCanadaStyles() {
    if (!StoreContainer.SettingStore.useIsLGCanada()) {
      return "";
    }

    return `.velaro-header .rating-container{
      border: 1px solid #646464;
      background: none;
   }

   .velaro-modal-header{
   color: #000000;
   }`;
  }

  getFormWidgetsCss() {
    const landingWidgetConfig = this.props.config.LandingWidgetsConfig;

    if (
      !landingWidgetConfig ||
      !landingWidgetConfig.FormWidgets ||
      !landingWidgetConfig.FormWidgets.length
    ) {
      return "";
    }

    let css = "";
    landingWidgetConfig.FormWidgets.forEach((widget, i) => {
      css += `.velaro-landing-widget-container .form-widget-${i} .widget-side-img{
        background-image: url('${widget.SideImageUrl}');
      }`;
    });
    return css;
  }

  render() {
    const { config } = this.props;
    const primaryBackgroundColor = this.getPrimaryBackgroundColor();
    const landingWidgetConfig = config.LandingWidgetsConfig;

    const mobile = screen.width < 600;
    return (
      <style type="text/css">{`
    #velaro-container-body,
    #velaro-container-body * {
        font-family: ${this.getFontFamily()};
    }

    .velaro-custom-footer{
        background: ${config.FrameBackgroundColor};
    }

    .velaro-custom-footer a{
        color: ${config.FrameTextColor};
  }

    .velaro-bg-primary,
    .velaro-default-launcher-inner {
        background: ${primaryBackgroundColor};
        color: ${config.PrimaryTextColor};
    }

    .velaro-text-primary {
        color: ${config.PrimaryTextColor};
    }

    .velaro-btn.primary{
        background: ${config.PrimaryButtonColor || primaryBackgroundColor};
        color: ${config.PrimaryButtonTextColor || "#FFFFFF"};
        border-width: ${config.PrimaryButtonBorderWidth}px;
        border-color: ${config.PrimaryButtonBorderColor};
    }

    .velaro-btn.secondary{
        background: ${config.SecondaryButtonColor || "#aaaaaa"};
        color: ${config.SecondaryButtonTextColor || "#FFFFFF"};
        border-width: ${config.SecondaryButtonBorderWidth}px;
        border-color: ${config.SecondaryButtonBorderColor};
    }

    .velaro-btn.danger{
        background: ${config.DangerButtonColor || "#b00c1a"};
        color: ${config.DangerButtonTextColor || "#FFFFFF"};
        border-width: ${config.DangerButtonBorderWidth}px;
        border-color: ${config.DangerButtonBorderColor};
    }

    .velaro-btn.reply{
        background: ${config.ReplyButtonColor};
        color: ${config.ReplyButtonTextColor};
        border-width: ${config.ReplyButtonBorderWidth}px;
        border-color: ${config.ReplyButtonBorderColor};
    }

    .velaro-btn{
      border-radius: ${config.ButtonRadius === undefined ? 3 : config.ButtonRadius
        }px;
    }
    
    .velaro-default-launcher-inner::after {
        border-top: 6px solid ${primaryBackgroundColor};
    }

   
    #velaro-container .velaro-messenger-frame>iframe {
        margin-top: ${!mobile || config.ExpandChatWindowMobile ? 0 : 5}vh;
    }

    #velaro-container .velaro-messenger-frames,
    #velaro-container .velaro-messenger-frame>iframe {
        border-radius: ${config.BorderRadius === undefined ? 18 : config.BorderRadius
        }px;
    }

    .velaro-message.agent .velaro-message-body .text,
    .velaro-message.bot .velaro-message-body .text {
        background: ${config.AgentChatBubbleBackgroundColor};
        color: ${config.AgentChatBubbleTextColor};
        border-color: ${config.AgentChatBubbleBorderColor};
    }

    .velaro-message.visitor .velaro-message-body .text {
        background: ${config.VisitorChatBubbleBackgroundColor};
        color: ${config.VisitorChatBubbleTextColor};
        border-color: ${config.VisitorChatBubbleBorderColor};
    }

    .velaro-message-list .timestamp, .velaro-message.notice .text {
      color: ${config.SystemTextColor};
    }

    .velaro-header-inner {
        background: ${this.getHeaderBackgroundColor()};
    }

    .velaro-available-launcher .velaro-custom-launcher-frame,
    .velaro-available-launcher .velaro-custom-launcher-frame iframe {
        border-radius: ${config.AvailableLauncherBorderRadius}px;
        right: ${config.AvailableLauncherX}px;
        bottom: ${config.AvailableLauncherY}px;
    }

    .velaro-custom-launcher.available {
      border-radius: ${config.AvailableLauncherBorderRadius}px;
    }

    .velaro-unavailable-launcher .velaro-custom-launcher-frame,
    .velaro-unavailable-launcher .velaro-custom-launcher-frame iframe {
        border-radius: ${config.UnavailableLauncherBorderRadius}px;
        right: ${config.UnavailableLauncherX}px;
        bottom: ${config.UnavailableLauncherY}px;
    }

    .velaro-custom-launcher.unavailable {
      border-radius: ${config.UnavailableLauncherBorderRadius}px;
    }

    .velaro-launcher-container .velaro-chatting-launcher-frame,
    .velaro-launcher-container .velaro-chatting-launcher-frame iframe {
        right: ${config.ChattingLauncherX}px;
        bottom: ${config.ChattingLauncherY}px;
    }

    .velaro-custom-launcher.available {
        padding: ${config.AvailableLauncherPadding}px;
    }

    .velaro-custom-launcher.unavailable {
      padding: ${config.UnavailableLauncherPadding}px;
    }

    #velaro-container .velaro-messenger-frame {
        width: ${config.FrameWidth || 460}px;
        max-height: ${config.FrameHeight || 700}px;
    }

    .velaro-intro-message-form,
    .velaro-survey,
    .velaro-queue,
    .velaro-message-list,
    .velaro-quick-replies,
    .velaro-invite-message-form,
    .velaro-landing-widget-container,
    .velaro-form-container,
    .velaro-referral-container {
        background: ${config.FrameBackgroundColor};
        color: ${config.FrameTextColor};
    }

    .velaro-available-eyecatcher {
        position: absolute;
        right: ${config.EyecatcherOnlineX - 60}px;
        bottom: ${config.EyecatcherOnlineY - 60}px;
        transform: scale(${config.EyecatcherOnlineScale / 100});
        -ms-transform: scale(${config.EyecatcherOnlineScale / 100});
    }

    .velaro-unavailable-eyecatcher {
        position: absolute;
        right: ${config.EyecatcherOfflineX - 60}px;
        bottom: ${config.EyecatcherOfflineY - 60}px;
        transform: scale(${config.EyecatcherOfflineScale / 100});
        -ms-transform: scale(${config.EyecatcherOfflineScale / 100});
    }

    .velaro-available-eyecatcher .eyecactcher-dismiss{
        transform: scale(${100 / config.EyecatcherOnlineScale});
        -ms-transform: scale(${100 / config.EyecatcherOnlineScale});
    }

    .velaro-unavailable-eyecatcher .eyecactcher-dismiss{
        transform: scale(${100 / config.EyecatcherOfflineScale});
        -ms-transform: scale(${100 / config.EyecatcherOfflineScale});
    }

    .velaro-header-headshot {
      border-radius: 50%;
      display: inline-block;
      overflow: hidden;
      ${this.getWidthHeightOrScale()}
    }

    .velaro-header-headshot img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .velaro-header-logo {
      ${this.getLogoWidthHeightOrScale()}
      margin-bottom: 16px;
    }

    .velaro-landing-widget-container .landing-widget{
      border-top: 3px solid ${landingWidgetConfig && landingWidgetConfig.WidgetPrimaryColor
        };
    }

    .velaro-landing-widget-container .widget-gradient{
      background-image: linear-gradient(
        90deg,
        ${landingWidgetConfig && landingWidgetConfig.WidgetPrimaryColor}66 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }

    .velaro-landing-widget-container .start-chat-widget .widget-side-img{
      background-image: url('${landingWidgetConfig &&
        landingWidgetConfig.StartChatWidget &&
        landingWidgetConfig.StartChatWidget.SideImageUrl
        }');
    }

    .velaro-landing-widget-container .kb-widget .widget-side-img{
      background-image: url('${landingWidgetConfig &&
        landingWidgetConfig.KBWidget &&
        landingWidgetConfig.KBWidget.SideImageUrl
        }');
    }

    ${this.getFormWidgetsCss()}

    ${this.getLGCanadaStyles()}

    .velaro-secure-form {
      text-align: center;
    }

    .velaro-carousel-item .search-spring-item{
      border: 2px solid ${this.addTransparencyToHexColor(
          this.getPrimaryBackgroundColor(),
          0.4
        )};
    }

        .velaro-carousel-item .search-spring-item i{
          color: ${primaryBackgroundColor};
    }
`}</style>
    );
  }
}

export default () => (
  <ConfigContext.Consumer>
    {(config) => <ConfigStyle config={config} />}
  </ConfigContext.Consumer>
);
